import styled, { keyframes } from 'styled-components'
import { Button } from '../Header/styles.js'


// 创建渐变动画
const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

export const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  background: #ffffff;
`

export const HeroContainer = styled.div`
  max-width: 166rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
`

export const HeroContent = styled.div`
  min-width: 40rem;
  flex:1;
  position: relative;
  z-index: 1;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    text-align: center;
    padding-top: 6rem;
  }
`
export const HeroImage = styled.div`
    background-size: cover;
    background-position: left bottom;
    height:84.7rem;
    width: 96rem;


  @media (max-width: 890px) {
    width:100%;
   aspect-ratio: 1 / 1;  // 保持 1:1 的宽高比
    height: auto;         // 让高度自动计算
  }
`

export const Title = styled.h1`
  font-size: 6.4rem;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: ${props => props.theme.colors.textPrimary};
`

export const Subtitle = styled.p`
  font-size: 2.4rem;
  padding: 3.2rem 0rem;
  @media (max-width: 890px) {
    padding: 3.2rem 4rem;
    width:100%;
  };
  color: ${props => props.theme.colors.textSecondary};
  line-height: 1.6;
`

export const CTAButton = styled(Button)`
  height: 6.4rem;
  width: 17.6rem;
  font-family: PingFangSC-Semibold;
  font-size: 2rem;
  color: #000000;
  font-weight: 600;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(254, 234, 0, 0.3);
  }
  @media (max-width: 890px) {
   display: none;
  }
`